angular.module('jv.Admin.Users.Administration.Controller', [
])
.controller('jvAdminUsersAdministrationController', ['$scope', '$window', function ($scope, $window) {

}]);
